'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../../core/translator');
const FormBuilder = require('./../../builder');
let ElementClass = require('./../../elementClass');

FormBuilder.register('instagram', function(config) {
    let self = {};
    let token = config.value.token;
    let interval;

    self = new ElementClass(config);

    self.getHtmlAuthMessage = function(message = '') {
        return `<div class="instagram-auth"><p class="text-center">${Translator.translate(message)}</p></div>`;
    };

    self.render = function($wrap) {
        if (token) {
            $wrap.html(self.getHtmlAuthMessage('auth_instagram_successfull'));
            return;
        }

        let $button = jQuery(`<div class="instagram-auth connect"><button class="btn btn-default" type="button">${Translator.translate('auth_instagram')}</button></div>`);

        $button.on('click', function() {
            let popin = window.open('https://instagram.com/oauth/authorize/?client_id=74c930ede8fd4f09af3a3bd51697533e&redirect_uri=http://backbee-cloud.local&response_type=token', '_blank', 'width=400,height=230');

            popin.onbeforeunload = function() {
                clearInterval(interval);
            };

            interval = setInterval(function() {
                if (popin.location.hash && popin.location.hash.length) {
                    clearInterval(interval);
                    token = popin.location.hash.slice(14);
                    $wrap.html(self.getHtmlAuthMessage('auth_instagram_successfull'));
                    popin.close();
                }
            }, 100);
        });

        $wrap.append($button);
    };

    self.getData = function() {
        let data = {};

        data.token = token || null;

        return data;
    };

    return self;
});
